import { z } from "zod/v4"
import { SpaceKey, SpaceKeySchema, UserId, UserIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"

export const UserActivityKindSpaceUser = z.literal("space-user")

export type UserActivityKindSpaceUser = z.infer<typeof UserActivityKindSpaceUser>

export const UserActivityValueSpaceUser = z.object({
  user_id: UserIdSchema.describe("共同メンバーとなったユーザーのID。"),
  space_key: SpaceKeySchema.describe("共同メンバーとなったスペースのキー。"),
  is_following: z.boolean().describe("このユーザーをフォローしているかどうか。"),
})

export type UserActivityValueSpaceUser = z.infer<typeof UserActivityValueSpaceUser>

export const UserActivitySpaceUser = z.object({
  kind: UserActivityKindSpaceUser,
  value: UserActivityValueSpaceUser,
})

export type UserActivitySpaceUser = z.infer<typeof UserActivitySpaceUser>

// Discriminated union for future extensibility
export const UserActivityDocumentMeta = z.discriminatedUnion("kind", [
  UserActivitySpaceUser,
  // Future: UserActivityLiveViewer, UserActivityPowerSent, etc.
])

export type UserActivityDocumentMeta = z.infer<typeof UserActivityDocumentMeta>

export const UserActivityDocumentBody = z.intersection(
  UserActivityDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type UserActivityDocumentBody = z.infer<typeof UserActivityDocumentBody>

export type UserActivityDocument = UserActivityDocumentBody & {
  id: string,
}

export class UserActivityDocuments {

  static toDocumentData(activity: UserActivityDocument): object {
    // id は document path に入るので除外する
    const { id, ...data } = activity
    return data
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserActivityDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      kind: data["kind"],
      value: data["value"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

  /**
   * Generate deterministic activity ID for space-user activities
   * Format: space-user:{target_user_id}:{space_key}
   */
  static generateSpaceUserActivityId(targetUserId: UserId, spaceKey: SpaceKey): string {
    return `space-user:${targetUserId}:${spaceKey}`
  }
}
